import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormFieldAbstractComponent } from '../abstract.component';
import { OverbookingGridMatInputComponent } from './overbooking-grid-mat-input.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';
import { UntypedFormControl } from '@angular/forms';
import { ModSlotLessonIntroService } from '@shared/shared/services/mod-slot-lesson-intro.service';
import { FormFieldsService } from '@shared/shared';
import { IntroLessonFormats } from '@shared/core/types';
import { SlotReserve } from '@shared/shared/form-fields';

@Component({
  selector: 'crm-form-field-overbooking-grid',
  templateUrl: './overbooking-grid.component.html',
  styleUrls: ['./overbooking-grid.component.scss'],
  providers: [ModSlotLessonIntroService],
  viewProviders: [provideTranslation('formFieldOverbookingGrid', () => import.meta.webpackContext!('./translation'))],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldOverbookingGridComponent extends FormFieldAbstractComponent implements OnInit, OnChanges {
  @Input() personTimeZone: string | null;
  @Input() format: IntroLessonFormats | null = null;
  @Output() slotSelected = new EventEmitter<SlotReserve>();

  timezonePersonControl = new UntypedFormControl();

  selectionTimezonePerson = [this.modSlotLessonIntroService.defaultTimeZone];

  defaultTimeZone = this.modSlotLessonIntroService.defaultTimeZone;

  initialSlotGrid = [];
  slotGridMod = [];
  gridName = 'grid';

  @ViewChild(OverbookingGridMatInputComponent)
  private gridInput: OverbookingGridMatInputComponent;

  constructor(
    protected formFieldsService: FormFieldsService,
    private modSlotLessonIntroService: ModSlotLessonIntroService,
  ) {
    super(formFieldsService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.isNotDefaultTimezone()) {
      this.selectionTimezonePerson.push(this.personTimeZone);
    }

    if (this.format === IntroLessonFormats.f2g) {
      this.gridName = 'gridF2g';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes?.field?.currentValue?.value?.length) {
      this.initialSlotGrid = this.parentFormGroup.get(this.gridName).value;
      if (this.isNotDefaultTimezone() && this.personTimeZone) {
        this.timezonePersonControl.setValue(this.personTimeZone);
        this.setUserTimezoneSlot();
      } else {
        this.timezonePersonControl.setValue(this.defaultTimeZone);
      }
    }
  }

  private isNotDefaultTimezone(): boolean {
    return this.personTimeZone !== this.defaultTimeZone && this.timezonePersonControl.value !== this.defaultTimeZone;
  }

  changeTimeZone(event): void {
    if (event.value !== this.defaultTimeZone) {
      this.setUserTimezoneSlot();
    } else {
      this.parentFormGroup.get(this.gridName).setValue(this.initialSlotGrid);
    }
  }

  setUserTimezoneSlot(): void {
    this.parentFormGroup
      .get(this.gridName)
      .setValue(
        this.modSlotLessonIntroService.getGridTimezone(
          this.personTimeZone,
          this.parentFormGroup.get(this.gridName).value,
        ),
      );
  }

  unselectSlot(): void {
    this.gridInput.unselectSlot();
  }

  onSlotSelected(startDatetime: string): void {
    this.slotSelected.emit({
      startDatetime: startDatetime,
      format: this.format,
    });
  }
}
